import { useCallback } from "react";
import { useFiltersStore } from "@/stores/filtersStore";
import { useImageSearchStore } from "@/stores/imageSearchStore";

/**
 * Returns a stable callback that performs a full search reset:
 * clears all active filters and exits image search mode.
 * Use this everywhere a "reset all search state" is needed.
 */
const useResetSearch = () => {
  const resetFilters = useFiltersStore((state) => state.actions.resetActiveFilters);
  const resetImageSearch = useImageSearchStore((state) => state.actions.reset);

  return useCallback(() => {
    resetFilters();
    resetImageSearch();
  }, [resetFilters, resetImageSearch]);
};

export default useResetSearch;
